import tw from "twin.macro";

export const Input = tw.input`px-2 py-1 border border-gray-400 mr-2`;
